import { cnpj } from 'cpf-cnpj-validator';

const validateCnpj = (number: string): boolean => cnpj.isValid(number);

export default validateCnpj;
